<template>
  <div id="zhiboHead" class="relativeItem">
    <div class="relativeItem">
      <div class="left radius3 relativeItem">
        <img class="absoluteItem radius50 centerY" :src="info.avatar" />
        <p class="p1 apostrophe">{{ info.nickname }}</p>
        <span class="no_p" v-if="month_pk_data.status == 0">未上榜</span>
        <div class="scroll-div" v-else>
          <p class="p2">
            <span class="yellow">当前{{ month_pk_data.msg }}&nbsp;&nbsp;</span
            ><span class="grey">{{ month_pk_data.shortmsg }}</span>
          </p>
        </div>

        <img
          class="rImg radius50 absoluteItem centerY"
          src="../../assets/zhibo (5).png"
          v-if="info.isfav != '0'"
          @click="download"
        />
        <img
          class="rImg radius50 absoluteItem centerY"
          src="../../assets/zhibo (6).png"
          @click="guanzhu"
          v-else
        />
      </div>

      <div id="lineScroll" class="right absoluteItem centerY" v-if="guanzhong">
        <ul id="rightHeadUl" class="flex-box">
          <li class="rightHeadli relativeItem" v-for="(n, index) in gz_num" :key="index">
            <a @click="download" class="allA"></a>
            <img
              class="imgBlock inhead"
              :src="guanzhonglist[index].headFrame"
              v-if="guanzhonglist[index].headFrame"
            />
            <img
              class="radius50 imgBlock"
              :class="{ inhead2: guanzhonglist[index].headFrame != '' }"
              :src="guanzhonglist[index].avatar"
            />

            <!--贡献值显示-->
            <div class="absoluteItem centerX" v-if="guanzhonglist[index].totalcost != 0">
              <img
                src="../../assets/live_gzpm(2).png"
                class="imgBlock"
                v-if="index == 0"
              />
              <img
                src="../../assets/live_gzpm(3).png"
                class="imgBlock"
                v-else-if="index == 1"
              />
              <img src="../../assets/live_gzpm(1).png" class="imgBlock" v-else />
              <span class="absoluteItem centerImg">{{
                guanzhonglist[index].totalcost
              }}</span>
            </div>
          </li>
        </ul>
      </div>

      <!--查看观众列表-->
      <!--热度统计-->
      <div class="people rImg radius50 absoluteItem centerY">
        <a @click="download" class="allA"></a>
        <img class="imgBlock" src="../../assets/hot.png" @click="show = !show" />
        <span>{{ info.heat }}</span>
      </div>
    </div>

    <!--魅力值-->
    <div class="meili flex-box">
      <div>
        <!--魅力值-->
        <p class="p1 meiliP arrow radius3 relativeItem" v-if="show_meili_pk">
          <a class="allA" @click="download"></a>
          {{ info.totalpoint }}
          <img
            class="imgBlock ml-img centerY absoluteItem"
            src="../../assets/meilizhi.png"
          />
        </p>
        <!--pk进度-->
        <div class="p1 pkph-p arrow radius3 relativeItem" v-if="!show_meili_pk">
          <router-link class="allA" to="/pklist4"></router-link>
          {{ seasonInfo.integral }}
          <!--包含进度条和段位图标 -->
          <div class="imgBlock pkph centerY absoluteItem">
            <span class="imgBlock absoluteItem centerY">
              <i
                class="imgBlock"
                :style="{ width: pk_pro + '%', background: pk_pro_bk }"
              ></i>
            </span>
            <img class="imgBlock" :src="seasonInfo.network_seasonLowImg" />
          </div>
        </div>
      </div>

      <p class="p2 radius3">朱贝&nbsp;{{ info.roomnumber }}</p>
    </div>

    <!--底部选项-->
    <div class="bottom absoluteItem">
      <img class="radius50" src="../../assets/videoIcon (5).png" @click="download" />
      <img class="radius50" src="../../assets/zhibo (3).png" @click="download" />
      <img class="radius50" src="../../assets/zhibo (4).png" @click="download" />
      <img class="radius50" src="../../assets/videoIcon (3).png" @click="goBack" />
    </div>
  </div>
</template>

<script>
import tool from "../../utils/tool";
import cookie from "../../utils/cookie";
import "../../utils/topAction.css";

export default {
  name: "zhiboHead",
  props: ["info", "seasonInfo", "month_pk_data"],
  data() {
    return {
      jsq: null, //魅力值和pk段位切换计时器
      show_meili_pk: true, //true 显示meili false pk
      pk_pro: 0, //pk段位的进度百分比
      pk_pro_bk: "",
      blank: false,
      ismore: true,
      page: 1,
      list: [],
      scroll_djs: null, //月榜排名滚动计时器的对象
      guanzIsmore: true, //观众列表是否有更多
      guanzhong: false,
      guanzhonglist: [],
      guanzhongPage: 1,
      gz_num: 3, //横向最多显示观众数量
      show: false, //显示贵宾
      see: 0, //0贵宾，1贡献，2观众
      // showlaba: true //是否显示喇叭
      // showAd: true, //是否现在左侧活动广告
    };
  },
  methods: {
    /**动态设置该组件ul的宽度 */
    setUlWidth() {
      let lis = tool.getByC("rightHeadli");
      let w = lis.length * 30 + lis.length * 10 + this.guanzhongPage * 10 + "px";
      //设置ul的宽度
      let ul = tool.getByID("rightHeadUl");
      ul.style.width = w;
      this.guanzhong = true;
    },
    //关注
    guanzhu() {
      if (!this.$tool.isStr(cookie.getC("token"))) {
        this.download();
        return;
      }

      let _this = this;
      let data = {
        roomnumber: this.$route.query.roomnumber,
      };
      this.$jsonp(this.$apis("guanzhu"), data, (res) => {
        if (res.data.data.result.state == 1) {
          _this.info.isfav = 1;
          _this.$tool.tip("关注成功");
        } else {
          _this.$tool.tip(res.data.data.result.msg);
        }
      });
    },
    /**下载APP */
    download() {
      //如果有uid就转到share页面 带上uid参数
      let data = [];
      if (this.$tool.isStr(this.$route.query.uid)) {
        data.push("uid");
        data.push(this.$route.query.uid);
        this.$tool.download(data);
      } else if (this.$tool.isStr(this.$route.query.u)) {
        data.push("u");
        data.push(this.$route.query.u);
        this.$tool.download(data);
      } else {
        this.$tool.download();
      }
    },
    /**退出直播 */
    goBack() {
      this.$router.go(-1);
    },
    /**获取观众席 */
    getGuanzhong() {
      if (!this.guanzIsmore) {
        return;
      }
      let _this = this;
      let data = {
        start: this.guanzhongPage,
      };
      if (this.$route.query.roomnumber != undefined) {
        data.roomnumber = this.$route.query.roomnumber;
      }
      this.$jsonp(this.$apis("guanzhong"), data, (res) => {
        let ls = res.data.data.result;
        if (ls.length == 0) {
          _this.guanzIsmore = false;
        } else {
          _this.gz_num = ls.length;
          if (_this.gz_num > 3) {
            _this.gz_num = 3;
          }

          for (let i = 0; i < 3; i++) {
            if (ls.avatar == "") {
              ls[i].totalcost = _this.$tool.million(parseInt(ls[i].totalcost * 1), "CN");
              ls[i].avatar = _this.$tool.getBlankImg();
            }
            _this.guanzhonglist.push(ls[i]);
          }
          _this.guanzhong = true;
          setTimeout(() => {
            _this.pk_pro = parseInt(
              ((_this.seasonInfo.integral * 1) / _this.seasonInfo.endExp) * 100
            );
            _this.seasonInfo.color = _this.seasonInfo.color.split(",");
            _this.pk_pro_bk = `linear-gradient(-45deg, ${_this.seasonInfo.color[0]},${_this.seasonInfo.color[1]})`;
            _this.scroll_pm();
          }, 1000);
        }
      });
    },
    /**横向滚动条滚动时间 */
    lineScroll() {
      let _this = this;
      let d = this.$tool.getByID("lineScroll");
      let left = null;
      let ul = this.$tool.getByID("rightHeadUl");
      let uW = ul.style.width.replace("px", "") * 1;
      let fw = this.$tool.getByID("zhiboHead").offsetWidth * 0.51;
      d.addEventListener("scroll", function (e) {
        left = e.target.scrollLeft;
        uW = ul.style.width.replace("px", "") * 1;
        if (uW - (left + fw) <= 40 && _this.guanzIsmore) {
          _this.guanzhongPage++;
          _this.getGuanzhong();
        }
      });
    },

    //下拉加载更多 */
    getMore() {
      let _this = this;
      let f = this.$tool.getByID("listB");
      let top = f.scrollTop;
      f.addEventListener("scroll", function (e) {
        top = e.target.scrollTop;
        let s = f.scrollHeight - top - f.offsetHeight <= 50;
        if (s && _this.ismore) {
          _this.page++;
          _this.getList();
        }
      });
    },

    /**月榜排名走马灯 */
    scroll_pm() {
      if (this.month_pk_data.status != 1) {
        console.log(1);
        return false;
      }
      let d = document.querySelector(".scroll-div");
      this.scroll_djs = setInterval(() => {
        d.scrollLeft += 1;
        if (d.scrollLeft >= 300) {
          d.scrollLeft = 0;
        }
      }, 50);
    },

    /**获取粉丝榜和富豪榜 */
    getList() {
      if (!this.ismore) {
        return;
      }
      let _this = this;
      let data = {
        start: this.page,
        roomnumber: this.$route.query.roomnumber,
      };
      let api = "";
      if (this.see == 0) {
        //粉丝贡献
        api = "zhiboFG";
      } else {
        //富豪
        api = "fuhao";
      }

      this.$jsonp(this.$apis(api), data, (res) => {
        let ls = res.data.data.result;
        if (ls.length == 0) {
          _this.guanzIsmore = false;
          if (_this.page == 1) {
            _this.blank = true;
          }
        } else {
          if (_this.page == 1) {
            _this.getMore();
          }
          for (let i = 0; i < ls.length; i++) {
            if (ls.avatar == "") {
              ls[i].avatar = _this.$tool.getBlankImg();
            }
            _this.list.push(ls[i]);
          }
        }
      });
    },

    /**魅力值和pk段位切换计时器 */
    meili_pk_qh() {
      let _this = this;
      this.jsq = setInterval(() => {
        _this.show_meili_pk = !_this.show_meili_pk;
      }, 10000);
    },
  },
  beforeDestroy() {
    //清楚定时器
    clearInterval(this.scroll_djs);
    clearInterval(this.jsq);
  },
  mounted: function () {
    /**获取观众席 */
    this.getGuanzhong();
    this.meili_pk_qh();
  },
  watch: {
    see() {
      this.page = 1;
      this.list = [];
      this.ismore = true;
      this.blank = false;
      this.blankText = false;
      this.getList();
    },
    show() {
      if (this.show) {
        this.getList();
      } else {
        this.page = 1;
        this.list = [];
        this.ismore = true;
        this.blank = false;
        this.blankText = false;
      }
    },
  },
};
</script>

<style scoped>
#zhiboHead {
  color: #fff;
  height: 100%;
}
.allA {
  z-index: 10;
}
.left {
  background: rgba(0, 0, 0, 0.2);
  font-size: 0.08rem;
  width: 37%;
  padding: 0.05rem 0;
  padding-left: 2.4rem;
}
.left .p1 {
  max-width: 70%;
  font-size: 13px;
  margin-bottom: 4px;
}
.left .no_p{
  display: block;
  font-size: 0.08rem;
}
.left .scroll-div {
  height: 14px;
  width: 60%;
  margin-bottom: 2px;
  overflow-x: scroll;
  padding-left: 60px;
}
.left .p2 {
  width: 300px;
  font-size: 0.5rem;
}
.left .p2 .yellow {
  color: #ffdd80;
}
.left .p2 .grey {
  color: rgba(255, 255, 255, 0.7);
}
.left img:first-child {
  width: 2.2rem;
  height: 2.2rem;
  left: 0;
}
.left .rImg {
  display: inline-block;
  right: 0.1rem;
  background: #fff;
  border: 1px solid #fd79a8;
  width: 1.9rem;
  height: 1.9rem;
  z-index: 1;
}
.people {
  width: 2.7rem;
  height: 2.2rem;
  right: 0;
  z-index: 4;
  background: rgba(255, 255, 255, 0.2);
}
.people img {
  width: 1rem;
  margin: 0 auto;
  margin-top: 2px;
}
.people span {
  display: block;
  text-align: center;
  font-size: 0.5rem;
  color: #fff;
}

.right {
  width: 62%;
  z-index: 2;
  left: 40%;
  overflow-x: scroll;
}
.zhezhao {
  display: inline-block;
  width: 20px;
  height: 100%;
  top: 0;
  right: 0;
  background: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.3)
  );
  background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3));
}
.right li {
  width: 35px;
  height: 35px;
}
.right ul {
  overflow: hidden;
  width: 77%;
  justify-content: flex-end;
}
.right li {
  margin-right: 6px;
}
.right li div {
  width: 100%;
  bottom: 0;
  height: 0.9rem;
  font-size: 0.5rem;
  z-index: 3;
}
.right li div img {
  width: 100%;
  height: 100%;
}
.right li .inhead {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 2;
}
.right li .inhead2 {
  position: absolute;
  width: 80%;
  height: 80%;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 1;
}
.right li:nth-child(1) span {
  color: #7d5118;
}
.right li:nth-child(2) span {
  color: #3b3f5c;
}
.right li:nth-child(3) span {
  color: #6a4117;
}

.meili {
  justify-content: space-between;
  font-size: 0.6rem;
  margin-top: 12px;
}
.meili .p1 {
  background: rgba(0, 0, 0, 0.2);
  padding-left: 3rem !important;
  margin-left: 1rem;
  animation: meili_pk 0.5s forwards;
}
.meili .meiliP {
  border: 1px solid #ff67d1;
}
.meili .p2 {
  font-size: 7px;
  transform: translateY(-38%);
  color: rgba(255, 255, 255, 0.7);
  font-family: kefu;
}
.meili p {
  padding: 0.2rem 0.5rem;
}
.meili .p1 {
  padding: 0.2rem 0.5rem;
  padding-right: 1.7rem;
}
.meili .p1::after {
  width: 0.4rem;
  height: 0.4rem;
  border-top: solid 1px #fff;
  border-right: solid 1px #fff;
}
.meili .ml-img {
  width: 4rem;
  left: -1.1rem;
}
.meili .pkph-p {
  padding-left: 5.2rem !important;
  margin-left: 0;
}
.meili .pkph {
  width: 5rem;
  left: 0;
}
.meili .pkph span {
  height: 48%;
  width: 82%;
  border-radius: 3rem;
  left: 12%;
  z-index: -1;
}
.meili .pkph i {
  border-radius: 3rem;
  max-width: 100%;
  height: 100%;
}

/*底部按钮*/
.bottom {
  text-align: right;
  width: 100%;
  overflow: hidden;
  bottom: 0;
}
.bottom img {
  width: 2.4rem;
  height: 2.4rem;
  margin-left: 0.5rem;
}
</style>
